import { CHROME } from '../constants';
import { CLASS_DRAGGABLE } from '../constants/config/parameters';

/**
 * @name handleFocus
 * @function
 * @description Removes the draggable attribute from the parent
 * @param {EventListenerObject} e Synthetic browser event
 */
export const handleFocus = e => {
    if( CHROME ) return;
    let parent = findDraggableParent( e.target );
    if( parent ) parent.setAttribute( CLASS_DRAGGABLE, false );
}

/**
 * @name handleBlur
 * @function
 * @description Adds the draggable attribute from the parent
 * @param {EventListenerObject} e Synthetic browser event
 */
export const handleBlur = e => {
    if( CHROME ) return;
    let parent = findDraggableParent( e.target );
    if( parent ) parent.setAttribute( CLASS_DRAGGABLE, true );
}

/**
 * @name findDraggableParent
 * @function
 * @description Traverses up the DOM for an element with the draggable class
 * @param {HTMLElement} element 
 */
const findDraggableParent = element => {
    if( element.nodeName !== 'SECTION' ) return findDraggableParent( element.parentElement );
    if( element.classList.contains( CLASS_DRAGGABLE ) ) return element;
    return null;
}